import React from 'react';

interface Props {
  className?: string;
  direction?: 'left' | 'right' | 'up' | 'down';
}

const Degrees = {
  left: 90,
  right: -90,
  down: 0,
  up: -180,
};

const Arrow: React.FC<Props> = ({ className, direction = 'down' }) => {
  const deg = Degrees[direction];

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `rotate(${deg}deg)` }}
      viewBox="0 0 20 20"
      width="1em"
      height="1em"
      fill="none"
    >
      <path
        fill="currentColor"
        d="m10 10.976 4.124-4.125 1.179 1.179L10 13.333 4.696 8.03 5.875 6.85 10 10.976Z"
      />
    </svg>
  );
};

export default Arrow;
